import { FC } from 'react'
import styled from 'styled-components'

type TProps = {
  isClose: boolean
}

const RecruitFilterDetailPanel: FC<TProps> = ({ isClose, children }) => {
  return <StyledWrapper isClose={isClose}>{children}</StyledWrapper>
}

export default RecruitFilterDetailPanel

const StyledWrapper = styled.div<{ isClose: boolean }>`
  width: calc(100% - 51px);
  height: calc(100% - 50px);
  background-color: #ffffff;
  position: absolute;
  top: 50px;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 1;
  overflow: hidden;
  ${({ isClose }) => {
    return isClose ? 'display: block' : 'display: none'
  }}

  .detail-panel {
    width: 100%;
    height: 100%;
  }
`
